import type { TextInputRef } from './TextInput.tsx';

export function TextInputClickThrough({
  children,
  inputRef
}: React.PropsWithChildren<{
  inputRef: React.RefObject<TextInputRef | null>;
}>) {
  return (
    <div
      className="flex cursor-text appearance-none items-center outline-hidden"
      onClick={() => inputRef.current?.focus()}
      role="button"
      tabIndex={-1}
    >
      {children}
    </div>
  );
}
